module.exports = __webpack_public_path__ + "img/formulastudent.fe075239.jpg";